import { useTranslation } from 'react-i18next'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@rentflowdev/ui'
import { DEFAULT_LOCALE } from '@/types'

export type HistoryEventKind = 'paid' | 'sent' | 'generated'

export interface HistoryEvent {
	kind: HistoryEventKind
	at:   string
}

interface HistoryListProps {
	events: HistoryEvent[]
}

function formatDateTime(iso: string): string {
	return new Date(iso).toLocaleString(DEFAULT_LOCALE, {
		day:    '2-digit',
		month:  '2-digit',
		year:   'numeric',
		hour:   '2-digit',
		minute: '2-digit',
	})
}

export function HistoryList({ events }: HistoryListProps) {
	const { t } = useTranslation()
	return (
		<Accordion type="single" collapsible defaultValue="history">
			<AccordionItem value="history" className="border-b-0">
				<AccordionTrigger className="px-0 py-2 text-sm font-[500] hover:no-underline">
					{t('rent.invoices.details.history.title')}
				</AccordionTrigger>
				<AccordionContent className="px-0 pb-0">
					<ul className="flex flex-col gap-3">
						{events.map((e, i) => (
							<li key={i} className="flex items-center justify-between gap-3 text-sm">
								<span className="text-(--color-foreground)">{t(`rent.invoices.details.history.${e.kind}`)}</span>
								<span className="text-(--color-muted-foreground)">{formatDateTime(e.at)}</span>
							</li>
						))}
					</ul>
				</AccordionContent>
			</AccordionItem>
		</Accordion>
	)
}
